const navTrigger = document.querySelector('.navTrigger');
const nav = document.querySelector('.nav');
const secondaryNavLinks = document.querySelectorAll('.secondaryNavLink');
const navBtns = document.querySelectorAll('.navBtn');

if (navTrigger) {

	navTrigger.addEventListener('click', () => {
		navTrigger.classList.toggle('is-active');
		nav.classList.toggle('is-active');
	})

	navBtns.forEach( (item) => {
		item.addEventListener('click', () => {
			item.classList.toggle('is-active');
			item.parentElement.classList.toggle('is-active');
		})
	})
}

if (secondaryNavLinks) {

	secondaryNavLinks.forEach( (item) => {
		item.addEventListener('mouseover', () => {
			let imageURL = item.getAttribute('data-image');
			let parentNav = item.closest('.secondaryNav');
			let navImage = parentNav.querySelector('.secondaryNavImage');

			console.log(imageURL);

			if (imageURL) {
				navImage.setAttribute('src', imageURL);
			}
		})
	})
}